import { Mail, MapPin } from "lucide-react";

export default function Footer() {
    return (
        <footer className="bg-brand-ink text-white/70" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-4 sm:px-8 py-14">
                <div className="grid md:grid-cols-3 gap-10 items-start">
                    <div>
                        <span className="inline-flex bg-white rounded-2xl px-4 py-2.5">
                            <img
                                src="/assets/logo.png"
                                alt="edunation — logo"
                                className="h-8 w-auto"
                                data-testid="footer-logo-image"
                            />
                        </span>
                        <p className="mt-5 text-sm leading-relaxed max-w-xs">
                            Platforma rozwoju dla nauczycieli języków obcych. Bezpłatne webinary,
                            szkolenia i materiały dydaktyczne.
                        </p>
                    </div>
                    <div>
                        <h3 className="text-white font-bold text-sm uppercase tracking-wider">Kontakt</h3>
                        <ul className="mt-4 space-y-3 text-sm">
                            <li className="flex items-start gap-3">
                                <MapPin className="w-4 h-4 mt-0.5 text-brand shrink-0" aria-hidden="true" />
                                <span>
                                    edunation Sp. z o.o.
                                    <br />
                                    ul. Złota 75 A/7, 00-819 Warszawa
                                    <br />
                                    NIP: 524-281-81-55
                                </span>
                            </li>
                            <li className="flex items-center gap-3">
                                <Mail className="w-4 h-4 text-brand shrink-0" aria-hidden="true" />
                                <a
                                    href="mailto:ewa.sierenska@edunation.com.pl"
                                    className="underline underline-offset-4 decoration-white/30 hover:text-white hover:decoration-brand transition-colors"
                                    data-testid="footer-email"
                                >
                                    ewa.sierenska@edunation.com.pl
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <h3 className="text-white font-bold text-sm uppercase tracking-wider">Informacje</h3>
                        <ul className="mt-4 space-y-3 text-sm">
                            <li>
                                <a
                                    href="https://edunation.com.pl/polityka-prywatnosci/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="underline underline-offset-4 decoration-white/30 hover:text-white hover:decoration-brand transition-colors"
                                    data-testid="footer-privacy-link"
                                >
                                    Polityka prywatności
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://edunation.com.pl/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="underline underline-offset-4 decoration-white/30 hover:text-white hover:decoration-brand transition-colors"
                                    data-testid="footer-website-link"
                                >
                                    edunation.com.pl
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="mt-12 pt-7 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/50">
                    <p data-testid="footer-copyright">
                        © 2026 edunation Sp. z o.o. Wszelkie prawa zastrzeżone.
                    </p>
                    <p>Bezpłatny webinar: „Ruch, muzyka, GRAmatyka: prosto i skutecznie"</p>
                </div>
            </div>
        </footer>
    );
}
